import GraphicObject from './GraphicObject';

export default class Texture extends GraphicObject {

	constructor(gl) {
		super(gl, gl.createTexture());
	}

	bind(unit = 0) {
		const gl = this._gl;
		gl.activeTexture(gl.TEXTURE0 + unit);
		gl.bindTexture(gl.TEXTURE_2D, this._object);
	}

	assign(image, mipmap) {
		const gl = this._gl;
		this.bind();
		gl.texImage2D(gl.TEXTURE_2D,
			/*level*/0,
			/*internalFormat*/gl.RGBA,
			/*srcFormat*/gl.RGBA,
			/*srcType*/gl.UNSIGNED_BYTE,
			image
			);
		/* Clean mipmap requires texture sizes to be power of two */
		if (mipmap) {
			gl.generateMipmap(gl.TEXTURE_2D);
		} else {
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
		}
	}

}
